import { makeStyles } from "@mui/styles";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import PrimaryButton from "@/components/UI/PrimaryButton/PrimaryButton";
import { ELEMENT_TYPE } from "@/constants";
import { getCurrentElement } from "@/store/actions";
import { simpleValuesSelector } from "@/store/selectors";

import VoiceMemoItem from "../VoiceMemoItem/VoiceMemoItem";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    height: 415,
    justifyContent: "space-between",
  },
  elements: {
    display: "flex",
    flexDirection: "column",
    padding: 16,
    gap: 16,
    backgroundColor: "#161616",
    maxHeight: 343,
    height: "100%",
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "6px",
      height: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#161616",
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
  },
});

export default function VoiceMemoReview(props) {
  const { propertyId, params, onCreate, onRemove, elements = [] } = props;

  const classes = useStyles();

  const simpleValues = useSelector(simpleValuesSelector);
  const selectedElementId = simpleValues.selectedElementId || null;

  useEffect(() => {
    if (selectedElementId) {
      document.getElementById(`element-${selectedElementId}`)?.scrollIntoView();
    }
  }, [selectedElementId]);

  const dispatch = useDispatch();

  const handleEdit = (element) => {
    dispatch(
      getCurrentElement({
        propertyId,
        experienceId: element.experienceId,
        mediaItemId: element.mediaItemId,
        elementId: element.id,
      }),
    );
  };

  return (
    <div className={classes.container} data-testid="voice-memo-review-container">
      <div className={classes.elements}>
        {elements.map((element) => (
          <VoiceMemoItem
            classes={classes}
            key={element?.id}
            element={element}
            onUpdate={handleEdit}
            onRemove={onRemove}
            selectedElementId={selectedElementId}
            params={params}
          />
        ))}
      </div>

      <PrimaryButton onClick={() => onCreate()} data-analytics={`${ELEMENT_TYPE.VOICE_MEMO}-create-new`}>
        Create
      </PrimaryButton>
    </div>
  );
}
